<!-- youtube-mobile-03 preview — YouTube watch ad (skippable in-stream) -->
<app-mobile-frame>
  <!-- START: Watch screen -->
  <div class="yt-w-screen">
    <!-- START: Player running the ad -->
    <div class="yt-w-player">
      <img
        *ngIf="thumbnailUrl; else noCreative"
        class="yt-m-creative-video"
        [src]="thumbnailUrl"
        alt=""
      />

      <ng-template #noCreative>
        <div class="yt-m-creative-video creative-missing">
          <ng-container *ngIf="isResolving; else askForVideo">
            Reading video formats&hellip;
          </ng-container>
          <ng-template #askForVideo>
            Add a {{ format }} video to see this preview
          </ng-template>
        </div>
      </ng-template>

      <!-- Player chrome. Fixed copy: it is the ad's frame, not the author's.
           Only drawn over a creative — it is white on white otherwise. -->
      <ng-container *ngIf="thumbnailUrl">
        <span class="yt-w-visit">Visit Advertiser</span>
        <span class="yt-w-skip">Skip Ad <i class="bi bi-skip-end-fill"></i></span>
        <span class="yt-m-countdown">00:08</span>
        <div class="yt-w-progress"><span class="yt-w-progress-fill"></span></div>
      </ng-container>
    </div>
    <!-- END: Player -->

    <!-- START: End card -->
    <div class="yt-w-card">
      <div
        class="yt-w-controls d-flex flex-row align-items-center justify-content-end gap-3"
      >
        <i class="bi bi-three-dots-vertical"></i>
        <i class="bi bi-x-lg"></i>
      </div>

      <div
        class="yt-w-body d-flex flex-column align-items-center justify-content-center"
      >
        <img
          class="yt-w-logo"
          src="assets/images/valamar_logo_80x80.jpg"
          alt=""
        />

        <div class="yt-w-url">{{ displayUrl }}</div>

        <h4 class="yt-w-headline">{{ headline }}</h4>
      </div>

      <a
        class="yt-w-cta"
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        >{{ data.ctaText || "Your call to action" }}</a
      >
    </div>
    <!-- END: End card -->
  </div>
  <!-- END: Watch screen -->

  <app-youtube-mobile-bottom-nav frameBottom></app-youtube-mobile-bottom-nav>
</app-mobile-frame>
